import CountrySlice from "../slices/CountrySlice";
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store/index";
import ProjectService from "../../services/ProjectService";
import { CountryModel } from "../../models/CountryModel";

export const CountryActions = CountrySlice.actions;
export const getAllCountries = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(CountryActions.setIsCountriesFetching(true));
    const response: CountryModel[] = await ProjectService.getAllCountries();
    dispatch(CountryActions.setAllCountries(response));
    dispatch(CountryActions.setIsCountriesFetching(false));
  };
};
